<app-dialog [dialogWithInput]="dialog">
    <div class="ion-text-center" *ngIf="service.loading$ | async">
        <app-loading text="Chargement des doublons potentiels"></app-loading>
    </div>
    <div class="ion-text-center" *ngIf="service.error$ | async as error">
        <app-error-text [error]="error"></app-error-text>
    </div>
    <app-card>
        <span *ngIf="result.length === 0">Aucun doublon</span>
        <app-item [entity]="item.partner" *ngFor="let item of result" (viewClicked)="redirectToFromCommandAction(partnerCommandService.partnerHome(item?.partner))" [displayViewButton]="true">
            <app-summary>
                <ng-container title>{{item.partner.name}}</ng-container>
                <ng-container content>
                    <app-lov-value-summary-field [lovValueSummary]="reason" *ngFor="let reason of item.reasons"></app-lov-value-summary-field>
                    <app-summary-field *ngIf="item.partner.businessNumber"
                                       [value]="item.partner.businessNumber"></app-summary-field>
                    <app-additional-property-label *ngFor="let prop of item.partner.additionalProperties"
                                                   [additionalProperty]="prop" [showLabel]="false"
                                                   [iconName]="prop.key === 'BIRTHDATE' ? 'calendar_month' : undefined">
                        <ng-container *ngIf="prop.key === 'BIRTHDATE'">
                            &nbsp;(<strong><app-age-label [date]="prop.value"></app-age-label></strong>)
                        </ng-container>
                    </app-additional-property-label>

                    <app-summary-field *ngIf="item.partner.email" iconName="mail">
                        <email [email]="item.partner.email"></email>
                    </app-summary-field>
                    <app-summary-field *ngIf="item.partner.phone" iconName="phone">
                        <app-phone-label [phone]="item.partner.phone"></app-phone-label>
                    </app-summary-field>
                    <app-summary-field *ngIf="item.partner.mobilePhone" iconName="phone">
                        <app-phone-label [phone]="item.partner.mobilePhone"></app-phone-label>
                    </app-summary-field>
                    <app-summary-field *ngIf="item.partner.officePhone" iconName="phone">
                        <app-phone-label [phone]="item.partner.officePhone"></app-phone-label>
                    </app-summary-field>
                    <app-summary-field [value]="address" iconName="map-pin"  *ngFor="let address of item.partner.addresses"></app-summary-field>
                </ng-container>
            </app-summary>
            <app-confirmation-button buttons iconName="x"
                        tooltip="Ne plus considérer comme doublon"
                        [loading]="removeSimilarService.loading$ | async"
                        (confirm)="removeSimilar(item.partner.id)"></app-confirmation-button>
            <app-button buttons iconName="arrow-merge"
                        tooltip="Fusionner"
                        (clickEvent)="merge(item.partner)"></app-button>
        </app-item>
    </app-card>
</app-dialog>
